// Register the service worker on page load. Keeps the hot path clean —
// errors are swallowed so a dev-env SW failure never crashes production.

export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  window.addEventListener("beforeinstallprompt", (e) => { window.__deferredInstallPrompt = e; });
  if (!("serviceWorker" in navigator)) return;
  // Only register in production builds — CRA dev server interferes with SW.
  if (process.env.NODE_ENV !== "production") return;
  window.addEventListener("load", () => {
    const staff = /^\/staff(\/|$)/.test(window.location.pathname);
    navigator.serviceWorker.register(staff ? "/staff/sw.js" : "/sw.js", { scope: staff ? "/staff/" : "/", updateViaCache: "none" }).catch(() => {
      /* swallow — SW failure must never break the app */
    });
  });
}

export default registerServiceWorker;
